import { ReactNode, useEffect, useRef, useState } from 'react';

type TipData = { x: number; y: number; title?: string; rows?: Array<{ label: string; value: string }>; html?: ReactNode } | null;

let globalSet: ((t: TipData) => void) | null = null;

export function showTooltip(data: TipData) {
  if (globalSet) globalSet(data);
}
export function hideTooltip() {
  if (globalSet) globalSet(null);
}

export default function TooltipHost() {
  const [tip, setTip] = useState<TipData>(null);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    globalSet = setTip;
    return () => {
      globalSet = null;
    };
  }, []);

  if (!tip) return null;
  const el = ref.current;
  const W = el?.offsetWidth ?? 180;
  const H = el?.offsetHeight ?? 40;
  const left = Math.max(8, Math.min(window.innerWidth - W - 8, tip.x + 12));
  const top = Math.max(8, Math.min(window.innerHeight - H - 8, tip.y - H - 10));
  return (
    <div ref={ref} className="chart-tooltip" style={{ left, top }}>
      {tip.title && <div className="tt-title">{tip.title}</div>}
      {tip.rows?.map((r, i) => (
        <div key={i} className="tt-row">
          <span style={{ opacity: 0.8 }}>{r.label} :</span> <strong>{r.value}</strong>
        </div>
      ))}
      {tip.html}
    </div>
  );
}
